export default {
  ValidateEmail:{
    ValidateEmail: "Validation de l'Email",
    connect:"Connection",
    returnToConnect:"Retour à la connection",
  },
  login: {
    title: "Connectez-vous pour commencer une session",
    email: "Adresse email",
    password: "Mot de passe",
    rememberMe: "Se souvenir de moi",
    forgotPassword: "Mot de passe oublié ?",
    register: "S'inscrire",
    connect: "Connexion",
    loading: "Chargement...",
    sessionExpiredRetry: "Une ancienne session invalide a été détectée et supprimée. Merci de réessayer de vous connecter."
  },
  forgotPassword: {
    title: "Réinitialiser le mot de passe",
    backToLogin: "Retour à la connexion",
    notify:{
      successTitle: "Email de réinitialisation envoyé",
      successText: "Regarder vos mails"
    }
  },
  projectChooseLogin: {
    title: "Choisissez un projet pour vous connecter",
    notify:{
      successText:"Redirection vers la page d'accueil",
    }
  },
  resetPasswordForm: {
    title: "Définissez votre nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    backToLogin:"Retour à la connexion",
    confirmPassword: "Confirmer le mot de passe",
    errorPswRewritten:"Les mots de passe ne correspondent pas.",
    notify:{
      successResetText:"Mot de passe modifié. Vous pouvez maintenant vous connecter.",
      errorResetText: "Une erreur est survenue"
    }
  },
  userRegister: {
    title: "Créez un compte pour rejoindre un projet",
    firstName: "Prénom",
    name: "Nom",
    email: "Adresse email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    inscription: "Inscription",
    backToLogin:"Retour à la connexion",
    notify:{
      errorPswTitle: "Échec de l'inscription",
      errorPswText: "Le mot de passe doit comporter entre 8 et 30 caractères, contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.",
      errorPswTitle2: "Échec de l'inscription",
      errorPswText2Form: "Formulaire invalide",
      errorPswText2Email: "Adresse e-mail invalide",
      successText:"Connectez vous",
    }
  },
};
